import { combineReducers } from "redux";
import { summaryReducer } from "./summary/summaryReducer";
import { dischargedReducer } from "./discharged/dischargedReducer";


export const dataReducer = combineReducers({
    summary: summaryReducer,
    discharged: dischargedReducer,
});
